import { SideContentProps } from '@components/SideContent/SideContent.types';

import { Settings } from './ui/Settings';
import { useTransactionFlow } from '../hooks/useTransactionFlow';

export function SettingsContainer({ setResult }: SideContentProps) {
  const { setSettings, settings } = useTransactionFlow();
  return <Settings setSettings={setSettings} settings={settings} setResult={setResult} />;
}
